import cn from 'classnames';
import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';

const Heading = ({ brandStylesOverrides = '', className = '', children }) => {
  const { brand } = useContext(BrandContext);

  return (
    <h1
      className={cn(className, brand, {
        ['h2 text-secondary']: !brandStylesOverrides,
        [brandStylesOverrides]: brandStylesOverrides,
      })}
    >
      {children}
    </h1>
  );
};

Heading.propTypes = {
  className: PropTypes.string,
  brandStylesOverrides: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Heading;
